import { render, staticRenderFns } from "./customerInfo.vue?vue&type=template&id=16eaa918"
import script from "./customerInfo.vue?vue&type=script&lang=js"
export * from "./customerInfo.vue?vue&type=script&lang=js"
import style0 from "./customerInfo.vue?vue&type=style&index=0&id=16eaa918&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports